import AuthService from "./service";

export * from "./reqres";

export default AuthService;
